module.exports = __webpack_public_path__ + "static/media/强化学习模拟.827a7949.png";